export default "/images/31cd076829494153e8ad4fa786e563df.avif";